import { type RoutePath, type RouteSegments, useSegments } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns `true` when the current route is within the modals stack,
 * indicating the screen is presented as an expo-router modal.
 */
export function useIsInModalStack() {
  const segments = useSegments();

  return segments[0] === MODALS_SEGMENT;
}

// ─── Constants ────────────────────────────────────────────────────────────────

const MODALS_SEGMENT = '(modals)' as const satisfies Segments[number];

// ─── Types ───────────────────────────────────────────────────────────────────

type Segments = RouteSegments<RoutePath>;
